// extracted by mini-css-extract-plugin
export default {"ldsRing":"Loader_ldsRing__-l3Fn","color":"Loader_color__kjZ99"};